import { extendTheme } from '@chakra-ui/react';

const customPalette = {
  snowy: '#FFFFFF',
  asphalt: {
    '1': '#7D838A',
    '2': '#B2B8BF',
    '3': '#D0D7DD',
    '4': '#E4E8EB',
    '5': '#F2F4F7',
  },
  graphite: {
    '1': '#1F1F22',
    '2': '#565B62',
    '3': 'B2B8BF',
    '4': 'E4E8EB',
    '5': 'F2F4F7',
  },
  malachite: {
    '1': '#005E7F',
    '2': '#107F8C',
    '3': '#21A19A',
    '4': '#90D0CC',
    '5': '#E5FCF7',
  },
  pumpkin: {
    '1': '#FFA446',
    '2': '#FF9900',
    '4': '#FFD9A0',
  },
};

export const theme = extendTheme({
  colors: {
    transparent: 'transparent',
    black: customPalette.graphite[1],
    white: customPalette.snowy,
    paper: customPalette.asphalt[5],
    grayText: customPalette.asphalt[1],
    hover: customPalette.asphalt[4],
    grayBorder: customPalette.asphalt[3],
    malachiteText: customPalette.malachite[2],
    ...customPalette,
  },
  breakpoints: {
    xs: '365px',
  },
  config: {
    initialColorMode: 'light',
  },
  fonts: {
    body: 'SBSansInterface',
  },
  textStyles: {
    h1: {
      fontSize: '2.5rem',
      lineHeight: '2rem',
    },
    h2: {
      fontSize: '1.31rem',
      lineHeight: '2rem',
      fontWeight: 'semibold',
    },
    h3: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
    },
    h4: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: 'semibold',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.43rem',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: '1rem',
    },
  },
});

export type CustomTheme = typeof theme;
